import styled from 'styled-components';

export const StyledLinkGroup = styled.nav.attrs((props) => {
  if (props.size === 'small') {
    return {
      containerSize: '170px',
      imageSize: '30px',
      fontSize: '0.8rem',
      containerPadding: '5px',
      border: 'none',
    };
  }
  return {
    containerSize: '220px',
    imageSize: '50px',
    fontSize: '1.2rem',
    containerPadding: '15px 25px',
    border: '2px solid',
  };
})`
  width: ${(props) => props.containerSize};
  padding: ${(props) => props.containerPadding};
  border: ${(props) => props.border};
  border-radius: 5px;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0 0 0 2px;
    font-size: ${(props) => props.fontSize};
    font-weight: 600;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      margin: 2px;
    }
    img {
      width: ${(props) => props.imageSize};
    }
  }
`;
